var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"share-cloud"}},[(_vm.isShowReload)?_c('share-error',{ref:"ShareError"}):_vm._e(),(_vm.testA)?_c('receive-applet-a',{attrs:{"cloudData":_vm.cloudData}}):_c('receive-applet-b',{attrs:{"cloudData":_vm.cloudData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }